import { render } from "./FormVenta.vue?vue&type=template&id=c74bff0e&scoped=true"
import script from "./FormVenta.vue?vue&type=script&lang=js"
export * from "./FormVenta.vue?vue&type=script&lang=js"

import "./FormVenta.vue?vue&type=style&index=0&id=c74bff0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74bff0e"]])

export default __exports__